import React from "react";
import "./styles.css";
import ChatViewImage from "../../assets/img/chat-view.png";
import ClientsViewImage from "../../assets/img/clients-view.png";
import FunnelViewImage from "../../assets/img//funnel-view.png";

function Demo() {
  return (
    <div className="demo__tabset">
      {/* Tab 1 */}
      <input
        type="radio"
        name="demo__tabset"
        id="chat-tab"
        aria-controls="chat-tab"
        defaultChecked={true}
      />
      <label htmlFor="chat-tab">Chat de Whatsapp</label>

      {/* Tab 2 */}
      <input
        type="radio"
        name="demo__tabset"
        id="clients-tab"
        aria-controls="clients-tab"
      />
      <label htmlFor="clients-tab">Todos tus clientes</label>

      {/* Tab 3 */}
      <input
        type="radio"
        name="demo__tabset"
        id="funnel-tab"
        aria-controls="funnel-tab"
      />
      <label htmlFor="funnel-tab">Embudo de ventas</label>

      {/* Contents */}
      <div className="demo__tab-panels">
        <section id="chat-tab" className="demo__tab-panel">
          <img src={ChatViewImage} alt="screenshoot of chat view" />
        </section>

        <section id="clients-tab" className="demo__tab-panel">
          <img src={ClientsViewImage} alt="screenshoot of clients view" />
        </section>

        <section id="funnel-tab" className="demo__tab-panel">
          <img src={FunnelViewImage} alt="screenshoot of funnel view" />
        </section>
      </div>
    </div>
  );
}

export default Demo;
